<template>
  <div class="table__theme-default">
    <div class="table-container container-fluid mt-3" style="border-radius:10px;">
      <div class="pb-0" style="font-size: 0.9rem">
        <p class="mb-1 ml-3">Compensation formula: <b>round(monthly compensation * exchange rate * reported hours / working hours)</b></p>
        <p class="mb-1 ml-3"><b>working hours</b> - сколько всего было рабочих часов по календарю (исключаем отпуска / праздники)</p>
        <p class="mb-1 ml-3"><b>logged hours</b> - сколько залогано в jira включая отпуска / праздники</p>
        <p class="mb-1 ml-3"><b>reported hours</b> - сколько дней/часов отмечено как reported</p>
      </div>
      <div class="table-controls-list">
        <div class="table-controls-item filter-datepicker">
          <b-button
            variant="light"
            @click.prevent="changeMonth('prev')"
          >
            ‹
          </b-button>
          <Datepicker
            :bootstrap-styling="true"
            :value="ym"
            :format="config.dateFormatDatePicker"
            :disabledDates="{
                      to: new Date(
                        fromDateToUTC(
                          ym,
                          'YYYY-MM'
                        )
                      ),
                      from: new Date(),
                    }"
            minimum-view="month"
            @selected="selectMonth"
          />
          <b-button
            variant="light"
            :disabled="ym === lastYm"
            @click.prevent="changeMonth('next')"
          >
            ›
          </b-button>
        </div>
        <div
          class="spinner-border spinner-theme_default"
          role="status"
          v-if="showPreloader"
        >
              <span class="sr-only">
                Loading...
              </span>
        </div>
      </div>
      <div id="compensation_summary_table" class="table-container table__theme-default">
        <table class="table b-table table-hover table-bordered">
          <thead>
            <tr>
              <th scope="col" class="text-center" colspan="12">Payroll (Предварительный расчет вознаграждения - по monthly compensation и exchange rate будут взяты фактические значения)</th>
            </tr>
            <tr class="d-flex">
              <th scope="col" class="th-else col-2 text-center">Specialist</th>
              <th scope="col" class="th-else col-1 text-center">Working hours</th>
              <th scope="col" class="th-else col-1 text-center">Logged hours</th>
              <th scope="col" class="th-else col-1 text-center">Reported hours</th>
              <th scope="col" class="th-else col-2 text-center">Monthly compensation</th>
              <th scope="col" class="th-else col-1 text-center">Exchange rate</th>
              <th scope="col" class="th-else col-3 text-center">Formula</th>
              <th scope="col" class="th-else col-1 text-center" style="font-weight:bold">Amount, UAH</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(userSummaryTime) in usersSummaryTime[ym]" :key="userSummaryTime.name" class="d-flex">
              <td scope="col" class="col-2">{{userSummaryTime.name}}</td>
              <td scope="col" class="text-center col-1">{{userSummaryTime.workingHours}}</td>
              <td scope="col" class="text-center col-1">{{userSummaryTime.loggedHours}}</td>
              <td scope="col" class="text-center col-1">{{userSummaryTime.reportedHours}}</td>
              <td scope="col" class="text-center col-2">{{userSummaryTime.monthlyCompensation}}</td>
              <td scope="col" class="text-center col-1">{{userSummaryTime.exchangeRate}}</td>
              <td scope="col" class="text-center col-3">{{userSummaryTime.formula}}</td>
              <td scope="col" class="text-center col-1">{{userSummaryTime.amount}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Datepicker from 'vuejs-datepicker'
import Moment from 'moment'

export default {
  name: 'compensation-summary-table',
  components: {
    Datepicker
  },
  data () {
    const dateFormat = 'YYYY-MM'
    const lastYm = Moment()
      .subtract(1, 'months')
      .format(dateFormat)
    return {
      showPreloader: false,
      config: {
        dateFormat,
        dateFormatDatePicker: 'yyyy-MM'
      },
      ym: lastYm,
      usersSummaryTime: {},
      lastYm
    }
  },
  computed: {
    ...mapGetters({
      dateFormat: 'dateFormat'
    })
  },
  created () {
    this.getReport(this.ym)
  },
  methods: {
    selectMonth (data) {
      this.ym = this._toLocalTime(data, this.config.dateFormat)
    },
    changeMonth (type) {
      const currentMonth = Moment(
        this.ym,
        this.config.dateFormat
      )
      if (type === 'next') {
        this.ym = currentMonth.add(1, 'months').format(this.config.dateFormat)
      } else {
        this.ym = currentMonth
          .subtract(1, 'months')
          .format(this.config.dateFormat)
      }
      if (this.usersSummaryTime[this.ym] === undefined) {
        this.getReport(this.ym)
      }
    },
    getReport (ym) {
      this.showPreloader = true
      this.axios
        .post(
          '/api/report/compensations-summary',
          { ym },
          {
            headers: {
              Authorization: 'Bearer' + this.$store.getters.getAccessToken
            },
            timeout: 60 * 4 * 1000
          }
        )
        .then(response => {
          if (response.status === 200) {
            this.usersSummaryTime[ym] = Object.values(response.data[ym])
          }
        })
        .catch(err => {
          var errors = Object.values(err.response.data.errors)
          for (var i = 0; i < errors.length; i++) {
            this.$snotify.error(
              errors[i][0],
              'Error',
              this.$store.state.snotify
            )
          }
        })
        .finally(() => {
          this.showPreloader = false
        })
    },
    onReset () {
      /* Trick to reset/clear native browser form validation state */
      this.$nextTick(() => {
        this.show = true
      })
    }
  }
}
</script>
<style>
  #compensation_summary_table table tr{
    border-right: 1px solid #E4E7EE;
  }
</style>
